import React__default from 'react';
import { ArticleFileAttachmentRelationLink } from './article-file-attachment-relation-link.esm.js';
import { ArticleRelationLink } from './article-relation-link.esm.js';

// Type guard for IArticleFileAttachmentRelationLink type
var isFileAttachment = function isFileAttachment(relationLink) {
  return !!relationLink.fileLabel;
};
var ArticleRelation = function ArticleRelation(props) {
  var relation = props.relation;
  var articleRelationLinks = relation.relationLinks.map(function (relationLink, index) {
    if (isFileAttachment(relationLink)) {
      return /*#__PURE__*/React__default.createElement("li", {
        key: index,
        className: "py-1",
        "automation-id": "related-file-attachment-".concat(index)
      }, /*#__PURE__*/React__default.createElement(ArticleFileAttachmentRelationLink, {
        fileLabel: relationLink.fileLabel,
        uri: relationLink.uri
      }));
    } else {
      return /*#__PURE__*/React__default.createElement("li", {
        key: index,
        className: "py-1"
      }, /*#__PURE__*/React__default.createElement(ArticleRelationLink, {
        link: relationLink
      }));
    }
  });
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("span", {
    className: "mb-1.5 inline-block font-sans text-p-16 font-bold leading-6 text-[#404040]"
  }, relation.title), /*#__PURE__*/React__default.createElement("ul", null, articleRelationLinks));
};

export { ArticleRelation };
//# sourceMappingURL=article-relation.esm.js.map
